import { cn } from "@babackapp/ui/lib/utils";
import { getSocialIconGlyphUrl } from "@babackapp/ui/lib/social-icons";
import { useMemo } from "react";
import { Column, Img, Link, Row } from "@react-email/components";
import type { SocialNetworksBlockProps } from "./types";
import { getSocialBadgeStyle } from "./social-badge-style";


export function SocialNetworksEmailRenderer({
                                              block,
                                              shop,
                                              section = "inside",
                                              theme,
                                            }: SocialNetworksBlockProps) {
  const alignment = block.alignment || "center";
  const variant = block.properties?.variant || "circle";
  const color = block.properties?.color || "default";

  const badge = getSocialBadgeStyle(theme, section, variant, color);

  const socialNetworks = useMemo(() => {
    return shop.externalLinks
      ? Object.entries(shop.externalLinks)
        .filter(([_, link]) => link?.type === "SOCIAL_NETWORK" && link?.url)
        .map(([platform, link]) => ({
          platform,
          url: link!.url,
          iconUrl: getSocialIconGlyphUrl(platform, badge.glyphColor),
        }))
      : [];
  }, [shop.externalLinks, badge.glyphColor]);

  if (socialNetworks.length === 0) {
    return null;
  }

  return (
    <Row>
      <Column
        className={cn({
          "text-left": alignment === "left",
          "text-center": alignment === "center",
          "text-right": alignment === "right",
        })}
      >
        {socialNetworks.map(({ platform, url, iconUrl }) => (
          <Link
            key={platform}
            href={url}
            className={cn("mx-1", badge.borderRadiusClass)}
            style={{
              display: "inline-block",
              textDecoration: "none",
              backgroundColor: badge.backgroundColor,
              padding: "5px",
              lineHeight: 0,
            }}
          >
            <Img
              src={iconUrl}
              alt={platform}
              width={18}
              height={18}
              style={{
                display: "block",
                width: "18px",
                height: "18px",
              }}
            />
          </Link>
        ))}
      </Column>
    </Row>
  );
}
